<template>
  <div class="cont-outer cont-outer-cont-3">
    <div class="container-landing cont-3 landing-cont" data-scroll>
      <div class="navig">
        <div class="prev-btn" @click="tochEve">
          <svg
            id="Group_1515"
            data-name="Group 1515"
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 60 60"
          >
            <g
              id="Ellipse_166"
              data-name="Ellipse 166"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            >
              <!-- <circle cx="30" cy="30" r="30" stroke="none" />
                <circle cx="30" cy="30" r="29" fill="none" /> -->
            </g>
            <g
              id="Group_104"
              data-name="Group 104"
              transform="translate(17 21)"
            >
              <g id="menu" transform="translate(0 0)">
                <g
                  id="Group_103"
                  data-name="Group 103"
                  transform="translate(0 0)"
                >
                  <path
                    id="Union_6"
                    data-name="Union 6"
                    d="M11.651,1.13a47.863,47.863,0,0,0,6.08,4.246c.587.348,1.189.681,1.808.97-.9.037-1.811,0-2.716-.037-.962-.04-1.912-.077-2.82-.032-3.919.212-7.8.931-11.731.857C.919,7.112-1.3,9.138.991,9.181c4.459.083,8.831-.8,13.278-.9.737-.014,1.49,0,2.252.021a24.421,24.421,0,0,0,5.028-.239c-2.2,2.309-4.712,4.311-6.6,6.9-.568.776-.117,2.053.66.986,2.278-3.126,5.475-5.4,7.917-8.384a1.282,1.282,0,0,0,.2-.348,1.021,1.021,0,0,0,.322-.781c0-.034,0-.067,0-.1-.02-.588-.86-.709-1.7-.514a11.6,11.6,0,0,1-4.386-2.012A53.817,53.817,0,0,1,12.95.245,1.152,1.152,0,0,0,12.215,0C11.529,0,10.9.514,11.651,1.13Z"
                    transform="matrix(-0.998, -0.07, 0.07, -0.998, 23.989, 18)"
                    fill="#fff"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="next-btn" @click="tochEve">
          <svg
            id="Group_1516"
            data-name="Group 1516"
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 60 60"
          >
            <g
              id="Ellipse_166"
              data-name="Ellipse 166"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            >
              <!-- <circle cx="30" cy="30" r="30" stroke="none" />
                <circle cx="30" cy="30" r="29" fill="none" /> -->
            </g>
            <g
              id="Group_104"
              data-name="Group 104"
              transform="translate(17.87 21)"
            >
              <g id="menu" transform="translate(0 0)">
                <g id="Group_103" data-name="Group 103">
                  <path
                    id="Union_6"
                    data-name="Union 6"
                    d="M11.651,15.232a47.863,47.863,0,0,1,6.08-4.246c.587-.348,1.189-.681,1.808-.97-.9-.037-1.811,0-2.716.037-.962.04-1.912.077-2.82.032-3.919-.212-7.8-.931-11.731-.857C.919,9.251-1.3,7.224.991,7.181c4.459-.083,8.831.8,13.278.9.737.014,1.49,0,2.252-.021a24.421,24.421,0,0,1,5.028.239c-2.2-2.309-4.712-4.311-6.6-6.9-.568-.776-.117-2.053.66-.986,2.278,3.126,5.475,5.4,7.917,8.384a1.282,1.282,0,0,1,.2.348,1.021,1.021,0,0,1,.322.781c0,.034,0,.067,0,.1-.02.588-.86.709-1.7.514a11.6,11.6,0,0,0-4.386,2.012,53.817,53.817,0,0,0-5.009,3.574,1.152,1.152,0,0,1-.735.245C11.529,16.362,10.9,15.848,11.651,15.232Z"
                    transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.677)"
                    fill="#fff"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="inner-outer-wrapper">
        <div class="text-box" data-scroll>
          <div class="ttl-wrapper" data-scroll>
            <h2 class="f-55">{{ _.get(contentData, "conf.header.title") }}</h2>
          </div>
          <p class="light-italic f-21">
            {{ _.get(contentData, "conf.header.teaser") }}
          </p>
          <div class="cocktail-box">
            <div class="prev-btn sm-only">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26.204"
                height="19.069"
                viewBox="0 0 26.204 19.069"
              >
                <g
                  id="Group_104"
                  data-name="Group 104"
                  transform="translate(0.534 0.535)"
                >
                  <g id="menu" transform="translate(0 0)">
                    <g id="Group_103" data-name="Group 103">
                      <path
                        id="Union_6"
                        data-name="Union 6"
                        d="M11.651,1.13a47.863,47.863,0,0,0,6.08,4.246c.587.348,1.189.681,1.808.97-.9.037-1.811,0-2.716-.037-.962-.04-1.912-.077-2.82-.032-3.919.212-7.8.931-11.731.857C.919,7.112-1.3,9.138.991,9.181c4.459.083,8.831-.8,13.278-.9.737-.014,1.49,0,2.252.021a24.421,24.421,0,0,0,5.028-.239c-2.2,2.309-4.712,4.311-6.6,6.9-.568.776-.117,2.053.66.986,2.278-3.126,5.475-5.4,7.917-8.384a1.282,1.282,0,0,0,.2-.348,1.021,1.021,0,0,0,.322-.781c0-.034,0-.067,0-.1-.02-.588-.86-.709-1.7-.514a11.6,11.6,0,0,1-4.386-2.012A53.817,53.817,0,0,1,12.95.245,1.152,1.152,0,0,0,12.215,0C11.529,0,10.9.514,11.651,1.13Z"
                        transform="matrix(-0.998, -0.07, 0.07, -0.998, 23.989, 18)"
                        fill="#fff"
                        stroke="#fff"
                        stroke-width="1"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="next-btn sm-only">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26.204"
                height="19.07"
                viewBox="0 0 26.204 19.07"
              >
                <g
                  id="Group_104"
                  data-name="Group 104"
                  transform="translate(0.54 0.535)"
                >
                  <g id="menu" transform="translate(0 0)">
                    <g id="Group_103" data-name="Group 103">
                      <path
                        id="Union_6"
                        data-name="Union 6"
                        d="M11.651,15.232a47.863,47.863,0,0,1,6.08-4.246c.587-.348,1.189-.681,1.808-.97-.9-.037-1.811,0-2.716.037-.962.04-1.912.077-2.82.032-3.919-.212-7.8-.931-11.731-.857C.919,9.251-1.3,7.224.991,7.181c4.459-.083,8.831.8,13.278.9.737.014,1.49,0,2.252-.021a24.421,24.421,0,0,1,5.028.239c-2.2-2.309-4.712-4.311-6.6-6.9-.568-.776-.117-2.053.66-.986,2.278,3.126,5.475,5.4,7.917,8.384a1.282,1.282,0,0,1,.2.348,1.021,1.021,0,0,1,.322.781c0,.034,0,.067,0,.1-.02.588-.86.709-1.7.514a11.6,11.6,0,0,0-4.386,2.012,53.817,53.817,0,0,0-5.009,3.574,1.152,1.152,0,0,1-.735.245C11.529,16.362,10.9,15.848,11.651,15.232Z"
                        transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.677)"
                        fill="#fff"
                        stroke="#fff"
                        stroke-width="1"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <h2 class="cocktail-ttl f-21 regular">
              {{ cTitle }}
            </h2>
            <h2 class="cocktail-desc f-16 light-italic">
              {{ cDesc }}
            </h2>
          </div>
          <router-link
            :to="_.get(contentData, 'conf.header.full_list_url')"
            class="read-more"
            data-scroll
          >
            <div class="inner-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="31.675"
                height="22.988"
                viewBox="0 0 31.675 22.988"
              >
                <g
                  id="Group_104"
                  data-name="Group 104"
                  transform="translate(25.293 -3.205)"
                >
                  <g id="menu" transform="translate(-24.754 3.74)">
                    <g
                      id="Group_103"
                      data-name="Group 103"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Union_6"
                        data-name="Union 6"
                        d="M14.188,18.549a58.283,58.283,0,0,1,7.4-5.171c.715-.424,1.448-.829,2.2-1.182-1.091-.045-2.205,0-3.308.045-1.171.049-2.329.094-3.434.039-4.772-.258-9.5-1.134-14.285-1.043-1.647.027-4.351-2.44-1.56-2.492,5.429-.1,10.753.977,16.168,1.092.9.017,1.815,0,2.742-.025a29.737,29.737,0,0,1,6.123.291C23.565,7.291,20.5,4.854,18.2,1.7c-.692-.945-.142-2.5.8-1.2,2.773,3.807,6.667,6.576,9.641,10.209a1.562,1.562,0,0,1,.248.424,1.243,1.243,0,0,1,.392.951c0,.042,0,.081,0,.118-.024.716-1.047.863-2.069.626a14.12,14.12,0,0,0-5.341,2.45,65.534,65.534,0,0,0-6.1,4.352,1.4,1.4,0,0,1-.9.3C14.039,19.925,13.278,19.3,14.188,18.549Z"
                        transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.043)"
                        fill="#044b30"
                        stroke="#044b30"
                        stroke-width="1"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <span class="f-30">{{
                _.get(contentData, "conf.header.full_list_title")
              }}</span>
            </div>
          </router-link>
        </div>
        <div class="cocktail-slider" data-scroll>
        
          <picture>
            <source media="(max-width:1919px)" srcset="@/assets/img/shmaxibg1680.png">
            <img src="@/assets/img/shmaxi.png" class="shmaxi-bg" />
         </picture>

          <swiper ref="cocktailSwiper" :options="cocktailOptions">
            <swiper-slide
              v-for="(slide, index) in sliderContent"
              :key="index"
              :c-title="slide.title"
              :c-desc="slide.desc"
            >
              <div class="cocktail-slide">
                <img :src="slide.path" alt="" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hammer from "../../helpers/hammer";
export default {
    props: ['contentData'],
  data() {
    let that = this;
    let ttl, desc;
    return {
      tochSlider: false,
      cTitle: "",
      cDesc: "",
      cocktailOptions: {
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: false,
        loop: true,
        speed: 600,
        slidesOffsetAfter: 501,
        grabCursor: true,
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn",
          disabledClass: "cocktail-slider-btn-disabled"
        },
        breakpoints: {
          1024: {
            centeredSlides: false
          },
          320: {
            centeredSlides: true
          }
        },
        on: {
          touchMove() {
            this.tochSlider = true;
          },
          init() {
            if (document.querySelector(".swiper-slide-active"))
              ttl = document
                .querySelector(".swiper-slide-active")
                .getAttribute("c-title");
            if (document.querySelector(".swiper-slide-active"))
              desc = document
                .querySelector(".swiper-slide-active")
                .getAttribute("c-desc");
            that.cTitle = ttl;
            that.cDesc = desc;
          },
          slideChange() {
            setTimeout(() => {
              if (this.tochSlider) {
                console.log(
                  document
                    .querySelector(".swiper-slide-active")
                    .getAttribute("data-swiper-slide-index")
                );
                that.$store.state.main.cocktailTarget = document
                  .querySelector(".swiper-slide-active")
                  .getAttribute("data-swiper-slide-index");
                that.$store.state.main.clickedOnCocktail = true;
              }

              if (document.querySelector(".swiper-slide-active"))
                ttl = document
                  .querySelector(".swiper-slide-active")
                  .getAttribute("c-title");
              if (document.querySelector(".swiper-slide-active"))
                desc = document
                  .querySelector(".swiper-slide-active")
                  .getAttribute("c-desc");

              that.cTitle = ttl;
              that.cDesc = desc;
            }, 200);
          }
        }
      }
    };
  },

  mounted() {
    this.$nextTick(() => {
      // this.initHammer();
    });
    console.log(this.$store.state.main.cocktailTarget);
  },
  methods: {
    tochEve() {
      setTimeout(() => {
        this.tochSlider = true;
        if (this.tochSlider) {
          console.log(
            document
              .querySelector(".swiper-slide-active")
              .getAttribute("data-swiper-slide-index")
          );
          this.$store.state.main.cocktailTarget = document
            .querySelector(".swiper-slide-active")
            .getAttribute("data-swiper-slide-index");
          this.$store.state.main.clickedOnCocktail = true;
        }
      }, 500);
    },
    // initHammer() {
    //   let that = this;
    //   let el = document.querySelector(".cocktail-slider .swiper-wrapper");
    //   let hammertime = new Hammer(el);
    //   hammertime.on("panstart", function(ev) {
    //     if (ev.pointerType !== "mouse") {
    //       that.stopScrolling();
    //     }
    //   });
    //   hammertime.on("panmove", function(ev) {
    //     if (ev.pointerType !== "mouse") {
    //       that.stopScrolling();
    //     }
    //   });
    // },

    // stopScrolling() {
    //   this.$store.commit(
    //     "main/galleryTouchToggler",
    //     (this.$store.state.main.galleryTouch = true)
    //   );
    // },

    // startScrolling(e) {
    //   e.preventDefault();
    //   e.stopPropagation();

    //   if (
    //     e.target ==
    //       document.querySelector(".cocktail-slider .swiper-wrapper") ||
    //     e.target.parentElement.parentElement ==
    //       document.querySelector(".cocktail-slider .swiper-wrapper")
    //   ) {
    //     this.$store.commit(
    //       "main/galleryTouchToggler",
    //       (this.$store.state.main.galleryTouch = true)
    //     );
    //   } else {
    //     this.$store.commit(
    //       "main/galleryTouchToggler",
    //       (this.$store.state.main.galleryTouch = false)
    //     );
    //   }
    // }
  },

  computed: {
    sliderContent() {
      let s_data = _.get(this.contentData, "data.list");
      let _dup = [];
      let __dup = [];
      let attr = this.$store.state.main.indx.attributes.ingredients;
      let cAttr = this.$store.state.main.indx.attributes.products_category;
      let newList = [];

      for (let i = 0; i < s_data.length; i++) {
        let newAttr = [];
        let type = [];
        let _oc = {
          title: s_data[i].title,
          path: s_data[i].images[0].url,
          desc: newAttr,
          type: type
        };

        let _attr = s_data[i].allAttributes;

        // s_data[i].allAttributes = newAttr;

        for (let k = 0; k < attr.length; k++) {
          for (let j = 0; j < _attr.length; j++) {
            if (_attr[j] == attr[k].id) {
              if (this.$route.name === "en")
                newAttr.push(" " + attr[k].title_en);
              if (this.$route.name === "ge")
                newAttr.push(" " + attr[k].title_ge);
            }
          }
        }

        for (let k = 0; k < cAttr.length; k++) {
          for (let j = 0; j < _attr.length; j++) {
            if (_attr[j] == cAttr[k].id) {
              type.push(cAttr[k].slug);
            }
          }
        }

        _dup.push(_oc);
      }

      for (let k = 0; k < _dup.length; k++) {
        let __oc = {
          title: _dup[k].title,
          path: _dup[k].path,
          desc: _dup[k].desc,
          type: _dup[k].type
        };
        if (_dup[k].type.includes("cocktails")) __dup.push(__oc);
      }

      return __dup;
    },
    swiper() {
      return this.$refs.cocktailSwiper.$swiper;
    }
  },
  // created() {
  //   window.addEventListener("touchmove", this.startScrolling, {
  //     passive: false
  //   });
  // }
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px){
.landing-wrapper .cont-3 .cocktail-slider{
  position: relative;
  &:after{
    position: absolute;
    content: "";
    opacity: 0;
    top: 0px;
    // right: -82px;
    left: -10px;
    z-index: 99;
    width: 136px;
    height: calc(100% + 30px);
    // transform: translatex(100%);
    background-image: none;
    background-image: linear-gradient(to right, rgba(4, 75, 48, 1) 50%, rgba(4, 75, 48, 0));
    transition: all 0.5s ease;
 transition-delay: 0s;

 @media (max-width: 1535px){
   left: -70px;
   width: 130px;
 }



  }
  &.green{
    &:after{
      transition-delay: 0.38s;
      opacity: 1;
        //  background-image: linear-gradient(to right, rgba(4, 75, 48, 1), rgba(4, 75, 48, 0));
    }
  }
}
}
</style>
